import $ from 'jquery';
import Utils from '@core/base/scripts/utils/utils';
import A11yUtils from '@core/base/scripts/utils/a11y-utils';
import 'select2/dist/js/select2.full.js';

export default class CollapsibleFilters {
  constructor(container, id) {
    this.container = container;
    this.FILTERS_ID = id;
    this.$btn = null;
    this.$filters = null;
  }

  init() {
    this.$btn = $('.collapsible-filters__header', this.container);
    this.$filters = $(`#${this.FILTERS_ID}`);
    //
    $('.form-select').select2({
      minimumResultsForSearch: -1,
      containerCssClass: 'js-form-type-select'
    });
    //
    this.onResize();
  }

  onResize() {
    this.$btn = $('.collapsible-filters__header');
    this.$filters = $(`#${this.FILTERS_ID}`);

    if (Utils.isTablet) {
      this.$btn
        .off()
        .attr('role', 'button')
        .attr(A11yUtils.ARIA.expanded, false)
        .attr(A11yUtils.ARIA.controls, this.FILTERS_ID)
        .attr('tabindex', 0);

      this.$btn.on('keydown', e => {
        if (e.which === A11yUtils.keyboard.space || e.which === A11yUtils.keyboard.enter) {
          this.toggle();
          return false;
        }
        return true;
      });

      this.$btn.on('click', e => {
        e.preventDefault();
        this.toggle();
      });
    } else {
      this.$btn
        .off()
        .removeAttr('role')
        .removeAttr(A11yUtils.ARIA.expanded)
        .removeAttr(A11yUtils.ARIA.controls)
        .removeAttr('tabindex');
      this.$filters.removeAttr('style');
    }
  }

  toggle() {
    const expanded = this.$btn.attr(A11yUtils.ARIA.expanded) === 'true';
    if (!expanded) {
      this.$filters.slideToggle(() => {
        this.$filters.find(A11yUtils.FOCUSABLES)[0].focus();
      });
      this.$btn.attr(A11yUtils.ARIA.expanded, true);
    } else {
      this.$filters.slideToggle(() => {
        this.$btn.focus();
      });
      this.$btn.attr(A11yUtils.ARIA.expanded, false);
    }
  }

}
